import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IncomeCallService } from 'src/app/_Common/_Services/income-call.service';
import { Subscription } from 'rxjs';
import { OzonetelDialerFlowService } from '../calling/ozonetel/ozonetel-dialer-flow.service';

@Component({
    selector: 'mt-ozonetel-iframe',
    templateUrl: './ozonetel-iframe.component.html',
    styleUrls: ['./ozonetel-iframe.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OzonetelIframeComponent implements OnInit, OnDestroy {
  iframeUrl: SafeResourceUrl;
  isMinimized = false;
  private socketSubscription: Subscription;

  isDragging = false;
  position = { x: 0, y: 0 };
  dragOffset = { x: 0, y: 0 };

  constructor(
    private incomeCallService: IncomeCallService,
    private sanitizer: DomSanitizer,
    private ozonetelDialerFlow: OzonetelDialerFlowService
  ) {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://agent.cloudagent.ozonetel.com/login');
    console.log('[OzonetelIframe] ✅ Component CONSTRUCTED');
    console.log('[OzonetelIframe] Iframe URL:', this.iframeUrl);
  }

  ngOnInit() {
    console.log('[OzonetelIframe] ✅ ngOnInit called - Component is RENDERING');
    console.log('[OzonetelIframe] isMinimized:', this.isMinimized);

    this.incomeCallService.intializeIncomeSocket();
    this.listenToCallEvents();
    this.setupMessageListener();
    this.setupDragging();

    setTimeout(() => {
      const element = document.querySelector('.ozonetel-iframe-container');
      console.log('[OzonetelIframe] DOM check - element found:', !!element);
      if (element) {
        console.log('[OzonetelIframe] Element styles:', window.getComputedStyle(element).display);
      }
    }, 500);
  }

  ngOnDestroy() {
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }
  }

  clearIframe() {
    console.log('[OzonetelIframe] Clearing iframe on logout');
    const iframe = document.querySelector('.ozonetel-iframe-container iframe') as HTMLIFrameElement;
    if (iframe) {
      iframe.src = 'about:blank';
      setTimeout(() => {
        iframe.src = 'https://agent.cloudagent.ozonetel.com/login';
      }, 100);
    }
  }

  private listenToCallEvents() {
    this.socketSubscription = this.incomeCallService.onMessage().subscribe((msgObj: any) => {
      try {
        const parsedMsg = typeof msgObj === 'string' ? JSON.parse(msgObj) : msgObj;
        if (parsedMsg && parsedMsg.dueId && parsedMsg.callingType === 'ozonetel') {
          console.log('[OzonetelIframe] Call event received:', parsedMsg);
          this.ozonetelDialerFlow.openCase(parsedMsg);
        }
      } catch (error) {
        console.error('[OzonetelIframe] Error parsing message:', error);
      }
    });
  }

  private setupMessageListener() {
    window.addEventListener('message', (event) => {
      if (event.origin !== 'https://agent.cloudagent.ozonetel.com') {
        return;
      }

      console.log('[OzonetelIframe] Message from iframe:', event.data);

      if (event.data.action) {
        this.handleOzonetelCallEvent(event.data);
      }
    });
  }

  private handleOzonetelCallEvent(data: any) {
    console.log('[OzonetelIframe] Call event from iframe - Full data:', data);
    console.log('[OzonetelIframe] Action:', data.action);
    console.log('[OzonetelIframe] Token:', data.token);

    if (data.action === 'newCall' && data.token) {
      this.handleNewCall(data.token);
    }
  }

  private async handleNewCall(token: any) {
    console.log('[OzonetelIframe] Processing newCall with token:', token);
    console.log('[OzonetelIframe] Available phone fields:', {
      callerId: token.callerId,
      customerNumber: token.customerNumber,
      phoneNumber: token.phoneNumber,
      did: token.did
    });

    const phoneNumber = token.callerId || token.customerNumber || token.phoneNumber || token.did;

    if (!phoneNumber) {
      console.warn('[OzonetelIframe] No phone number found in token');
      return;
    }

    console.log('[OzonetelIframe] Looking up case for phone:', phoneNumber);

    try {
      const caseData = await this.ozonetelDialerFlow.openCaseFromCall({
        ...token,
        phoneNo: phoneNumber,
        Status: 'CONNECTED',
      });

      console.log('[OzonetelIframe] Case lookup response:', caseData);

      if (!caseData) {
        console.warn('[OzonetelIframe] No case found for phone:', phoneNumber);
      } else {
        console.log('[OzonetelIframe] Case opened for phone:', phoneNumber);
      }
    } catch (error) {
      console.error('[OzonetelIframe] Error looking up case:', error);
    }
  }

  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
  }

  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.dragOffset.x = event.clientX - this.position.x;
    this.dragOffset.y = event.clientY - this.position.y;
    event.preventDefault();
  }

  setupDragging() {
    document.addEventListener('mousemove', (event) => {
      if (this.isDragging) {
        this.position.x = event.clientX - this.dragOffset.x;
        this.position.y = event.clientY - this.dragOffset.y;
      }
    });

    document.addEventListener('mouseup', () => {
      this.isDragging = false;
    });
  }

  getTransform(): string {
    return `translate(${this.position.x}px, ${this.position.y}px)`;
  }
}
